import { useEffect } from "react";
import { useState } from "react";
import moment from "moment";
import {
  GeneralPaymentDetails,
  InitiateSchoolFeePayment,
} from "../../api/student";
import SchoolFeeComponent from "../../components/SchoolFeeComponent";
import Footer from "../../components/Footer";
import { getCurrentUser } from "../../utils/authService";
import { toast } from "react-toastify";
import usePayments from "../../hooks/usePayments";
import api from "../../api/api";
import { LuArrowUpRight, LuArrowRight } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import useDetails from "../../hooks/useDetails";
import useActiveSession from "../../hooks/useActiveSession";
import { paymentTypes, sessionList } from "../../utils";

const OtherFees = () => {
  const user = getCurrentUser();
  const [schoolFee, setSchoolFee] = useState();
  const [loading, setLoading] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [paymentLevel, setPaymentLevel] = useState("");
  const [paymentSession, setPaymentSession] = useState("");
  const [paidSchoolFee, setPaidSchoolFee] = useState(false);
  const [showAmount, setShowAmount] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [btnText, setBtnText] = useState("Proceed to payment");
  const navigate = useNavigate();
  const { session } = useActiveSession();
  const { data } = useDetails();
  const { payment, schoolFeesPayment } = usePayments();

  const getPaymentDetails = async () => {
    if (!paymentType || !paymentLevel || !paymentSession) return;
    setLoading(true);
    setShowAmount(false);
    try {
      const { data } = await api.post("/payments/generate/payment/", {
        student_id: user.role_id,
        payment_type: paymentType,
        level: paymentLevel,
        session_id: Number(paymentSession),
      });
      console.log("ccccc", data);
      setLoading(false);
      setSchoolFee(data);
      setShowAmount(true);
    } catch (error) {
      console.log(error, "errrorrr");
      setLoading(false);
      toast.error(
        error.response.data.detail || "Error fetching payment details",
      );
      setShowAmount(false);
      setSchoolFee(null);
      setPaymentType("");
      setPaymentLevel("");
      setPaymentSession("");
    }
  };

  const paySchoolFee = async () => {
    try {
      setBtnText("Initializing...");
      setLoading(true);
      const data = await InitiateSchoolFeePayment({
        student_id: user.role_id,
        payment_type: paymentType,
        custom_amount: schoolFee?.amount,
        session_id: Number(paymentSession),
      });
      console.log("payment oh", data);
      const { payment_link } = data;
      toast.success("Initiating payment");
      window.location.replace(payment_link);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      toast.error(error.response.data.detail || "Initiating payment failed!");
      setBtnText("Initiating payment failed!");
    }
  };

  const getSession = async () => {
    try {
      const {data} = await api.get("/portal/academic-sessions/");
      setSessions(data?.results);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  useEffect(() => {
    getPaymentDetails();
  }, [paymentType, paymentLevel, paymentSession]);

  useEffect(() => {
    if (schoolFeesPayment && session) {
      // Check if any payment matches the active session
      const hasPaid = schoolFeesPayment.some(
        (payment) => payment.payment_session === session.name
      );
      setPaidSchoolFee(hasPaid);
    }
  }, [schoolFeesPayment, session]);
  return (
    <>
      <div>
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <h1 className="text-2xl font-bold text-brand-darkGray">
              Other Fees
            </h1>
            <p className="text-sm text-gray-400">View all payments</p>
          </div>

          <div className="flex gap-3">
            <button
              className="bg-[#5D71C0] py-2 px-3 flex items-center gap-4 md:gap-9 border border-[#E2D49A80] rounded-xl hover:bg-[#5D71C0]/95 hover:scale-105 transition-all ease-in-out"
              onClick={() => navigate("/payments")}
            >
              <p className="text-sm font-medium text-white">Invoice</p>
              <div className="size-9 bg-[#1E2F733B] rounded-lg flex justify-center items-center cursor-pointer group">
                <LuArrowUpRight className="size-[18px] text-white group-hover:scale-125 transition-all ease-in-out" />
              </div>
            </button>
          </div>
        </div>

        <div className="mt-6 card-body rounded-xl bg-white space-y-10">
          <h5 className="text-lg font-semibold text-brand-darkGray">
            &#x2022; Student information
          </h5>

          <div className="w-full space-y-5">
            <div className="flex flex-col lg:flex-row gap-5">
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600">
                  Matriculation Number
                </label>
                <input
                  type="text"
                  defaultValue={data?.matric_number}
                  className="form-control text-black font-semibold"
                  disabled
                />
              </div>
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600">
                  Academic Session
                </label>
                <input
                  type="text"
                  defaultValue={session?.name}
                  className="form-control text-black font-semibold"
                  disabled
                />
              </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-5">
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600">
                  Faculty
                </label>
                <input
                  type="text"
                  defaultValue={data?.faculty}
                  className="form-control text-black font-semibold"
                  disabled
                />
              </div>
              <div className="w-full">
                <label className="text-sm font-medium text-gray-600">
                  Department
                </label>
                <input
                  type="text"
                  defaultValue={data?.department}
                  className="form-control text-black font-semibold"
                  disabled
                />
              </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-5">
              <div className="w-full lg:w-[49.3%]">
                <label className="text-sm font-medium text-gray-600">
                  Fee Payment
                </label>
                <input
                  type="text"
                  value={paidSchoolFee ? "Paid" : "Not Paid"}
                  className="form-control text-black font-semibold"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>

        <div class="p-6 bg-white rounded-xl shadow-md mt-6 card-body  space-y-10 overflow-hidden">
          <div className="">
            <h2 class="text-lg font-semibold mb-4"> &#x2022; Payment</h2>
          </div>

          <div class="overflow-x-auto  flex items-center justify-between gap-3">
            <div className="w-full">
              <label className="text-sm font-medium text-gray-600">
                Select the payment you want to make
              </label>
              <div className="w-full lg:w-[56%]">
                <select
                  className="form-control text-gray-600 font-semibold bg-slate-100"
                  value={paymentType}
                  onChange={(e) => setPaymentType(e.target.value)}
                >
                  <option value="">{`--Select--`}</option>
                  {paymentTypes.map((option, index) => (
                    <option key={index} value={option.key}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <label className="text-sm font-medium text-gray-600 mt-4">
                Select the level
              </label>
              <div className="w-full lg:w-[56%]">
                <select
                  className="form-control text-gray-600 font-semibold bg-slate-100"
                  value={paymentLevel}
                  onChange={(e) => setPaymentLevel(e.target.value)}
                >
                  <option value="">{`--Select--`}</option>
                  {["700", "800"].map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <label className="text-sm font-medium text-gray-600 mt-4">
                Select the session
              </label>
              <div className="w-full lg:w-[56%] ">
                <select
                  className="form-control text-gray-600 font-semibold bg-slate-100"
                  value={paymentSession}
                  onChange={(e) => setPaymentSession(e.target.value)}
                >
                  <option value="">{`--Select--`}</option>
                  {sessions.map((option, index) => (
                    <option key={index} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          {showAmount && (
            <div className="flex flex-col">
              <div className="bg-blue-50 px-4 py-8 rounded-md text-4xl">
                {Number(schoolFee?.amount).toLocaleString("en-NG", {style:"currency", currency:"NGN"})}
              </div>
              <div className="flex pt-4">
                <button
                  className="bg-[#5D71C0] py-2 px-3 flex items-center gap-4 md:gap-9 border border-[#E2D49A80] rounded-xl hover:bg-[#5D71C0]/95 hover:scale-105 transition-all ease-in-out"
                  onClick={() => paySchoolFee()}
                >
                  <p className="text-sm font-medium text-white">{btnText}</p>
                  <div className="size-9 bg-[#1E2F733B] rounded-lg flex justify-center items-center cursor-pointer group">
                    <LuArrowRight className="size-[18px] text-white group-hover:scale-125 transition-all ease-in-out" />
                  </div>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default OtherFees;
